import * as React from 'react';
import { connect } from 'react-redux';
import DriverReportForm from '../../Forms/DriverReportForm/DriverForm';
import { completeDriverReport } from './redux-objects/actions';
import { GetURIByParts } from '../../../services/Utils/StringUtils';
import { Button, Col, Form, Row } from 'react-bootstrap';
import * as documentDownloadService from '../../../services/documentDownloadService';
import { UserInfo } from '../../Login/common/defaults';
import * as urls from '../../shared/urls';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IAppRouteLocation, IWorkflowItemStep } from '../../../common/sharedTypes';
import './driverreport.css';
import { toast } from 'react-toastify';
import CommentsButton from '../../Comments/CommentsButton';
import CorrespondenceButton from '../../Correspondence/CorrespondenceButton';
import NotificationTemplateSelector from '../../NotificationTemplate/NotificationTemplateSelector';
import * as optionIds from '../../shared/optionIds';
import InfoButtonBar from '../common/InfoButtonBar';

enum ServiceEndPoints {
  CompleteDriverReport = 'CompleteDriverReport',
  SaveDriverReport = 'SaveDriverReport',
  GetPaperPdf = 'GetPaperPdf',
}

export interface IDriverReportActionProps {
  completeDriverReport?: (
    url: string,
    itemStep: IWorkflowItemStep,
    data: any,
    moveToNextWorkflow: boolean,
    assignNext: boolean
  ) => Promise<ApiResponse<any>>;
}

interface IDriverReportStateProps {
  openWorkflowItemStep?: IWorkflowItemStep;
  webServiceURL: string;
  isProcessing: boolean;
  currentUser: UserInfo;
}

interface IDriverReportOwnProps {
  history: any;
  data?: any;
  crashKey?: any;
  readOnly?: boolean;
}

interface IDriverReportProps
  extends IDriverReportStateProps,
  IDriverReportOwnProps,
  IDriverReportActionProps { }

interface IDriverReportOwnState {
  data: any;
  formIsValid: boolean;
}

class DriverReport extends React.Component<
  IDriverReportProps,
  IDriverReportOwnState
> {
  private workflowController: string = 'Workflow';
  driverReportForm = null;
  backgroundSave;
  saving = false;

  state = {
    data: {},
    formIsValid: false,
  };
  private crashKey: any;

  componentDidMount() {
    if (this.props.data == undefined)
      this.getDriverReportJsonData(this.props.openWorkflowItemStep);
    else {
      this.setState({ data: this.props.data });
    }

    this.handleOpenPdf();

    if (!this.backgroundSave) {
      this.backgroundSave = setInterval(() => {
        if (this.props.openWorkflowItemStep && !this.saving)
          this.handleComplete(null, false, false, false);
      }, 30000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.backgroundSave);
    this.backgroundSave = null;
  }

  getDriverReportJsonData = (openWorkflowItemStep: IWorkflowItemStep) => {
    let id;
    if (openWorkflowItemStep != null) {
      id = { id: openWorkflowItemStep.workflowItemId.toString() };
      this.crashKey = openWorkflowItemStep.workflowItem.report.keywords.crashKey.toString();
    } else {
      id = '0';
      this.crashKey = '0';
    }

    if (this.crashKey == null) {
      this.crashKey = 'No Crash Key Available';
    }

    Api.post(urls.GET_REPORT_VALIDATION_JSON, JSON.stringify(id)).then(
      (response: ApiResponse<any>) => {
        if (response.ok) this.setState({ data: response.data });
      }
    );
  };

  checkIsFormValid = (submission: any) => {
    console.log('form submission', submission);
    this.setState({ data: submission });
    if (this.driverReportForm) {
      this.setState({ formIsValid: this.driverReportForm.isFormValid() });
    }
  };

  handleComplete(
    event: React.MouseEvent<HTMLElement>,
    assignNext: boolean,
    moveToNextWorkflow: boolean,
    continueNavigation: boolean = true,
    manualSave: boolean = false
  ) {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.CompleteDriverReport
    );
    this.saving = true;

    const formData = this.state.data;
    console.log('form data: ', formData);

    this.props
      .completeDriverReport(
        uri,
        this.props.openWorkflowItemStep,
        this.state.data,
        moveToNextWorkflow,
        assignNext
      )
      .then((result: ApiResponse<any>) => {
        if (!result.ok) {
          toast.error('Error saving!');
          return;
        }
        this.saving = false;
        if (continueNavigation) {
          if (assignNext) {
            this.props.history.push('/DriverReport');
          }
          else {
            this.props.history.push('/DataTranscriberValidationQueue');
          }
        } else {
          if (manualSave) {
            toast.success('Saved');
          }
        }
      });
  }

  openPaperReport() {
    const uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.GetPaperPdf
    );
    documentDownloadService
      .paperReport(
        uri,
        this.props.openWorkflowItemStep.workflowItem.report.paperReportId
      )
      .then(() => console.log('got')); //this.setState({ ...this.state, isGenerating: false }));
  }

  handleOpenPdf = () => {
    documentDownloadService
      .openOnBaseImage(
        null,
        this.props.openWorkflowItemStep.workflowItem.report.keywords.documentId
      )
      .then();
  }

  sendToManagementQueue = () => {
    try {
      Api.post(urls.SEND_TO_MANAGEMENT_QUEUE, {
        workflowItemStepId: this.props.openWorkflowItemStep.id,
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          let location: IAppRouteLocation = {
            pathname: '/DataTranscriberValidationQueue',
          };
          this.props.history.push(location);
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };

  public render() {
    const allButtons = (
      <React.Fragment>
        <br />
        <div className='completeAndStartNextButton'>
          <Button
            variant='success'
            size='sm'
            onClick={(e) => this.handleComplete(e, true, true)}
            disabled={!this.state.formIsValid}
          >
            Complete and Start Next Report
          </Button>
        </div>
        <div className='completeButton'>
          <Button
            variant='success'
            size='sm'
            onClick={(e) => this.handleComplete(e, false, true)}
            disabled={!this.state.formIsValid}
          >
            Complete
          </Button>
        </div>
        <div className='saveReportButton'>
          <Button
            variant='success'
            size='sm'
            onClick={(e) => this.handleComplete(e, false, false, false, true)}
          >
            Save Draft
          </Button>
        </div>
      </React.Fragment>
    );

    return (
      <div>
        <Row>
          <Col className='justify-content-end'>
            {' '}
            <NotificationTemplateSelector
              optionId={optionIds.transcribeValidationOptionId}
              reportId={this.props.openWorkflowItemStep.workflowItem.reportId}
            />
          </Col>
          <Col xs={2} className='justify-content-end'>
            <CommentsButton
              reportId={this.props.openWorkflowItemStep.workflowItem.reportId}
              className='pull-right'
              placement='left'
            />
            <CorrespondenceButton
              reportId={this.props.openWorkflowItemStep.workflowItem.reportId}
              className='pull-right mr-10'
            />
          </Col>
        </Row>
        <InfoButtonBar
          report={this.props.openWorkflowItemStep.workflowItem.report}
          handleOpenPdf={this.handleOpenPdf}
          sendToManagementQueue={this.sendToManagementQueue}
        />
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <DriverReportForm
          data={this.state.data}
          injectToSidebar={allButtons}
          ref={(el) => (this.driverReportForm = el)}
          onChange={this.checkIsFormValid}
          formId={this.props.openWorkflowItemStep.workflowStep.formIoFormId}
        />
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    openWorkflowItemStep:
      state.DataTranscriberValidationQueue.openWorkflowItemStep,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  completeDriverReport,
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverReport);
